import {
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_SUCCEEDED,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_FAILED,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_SUCCEEDED,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_FAILED,
  FETCHING_NEW_ACCOUNTS,
  FETCHING_NEW_ACCOUNTS_SUCCEEDED,
  FETCHING_NEW_ACCOUNTS_FAILED,
  FETCHING_CHURNED_ACCOUNTS,
  FETCHING_CHURNED_ACCOUNTS_SUCCEEDED,
  FETCHING_CHURNED_ACCOUNTS_FAILED,
  FETCHING_TRIAL_ACCOUNTS,
  FETCHING_TRIAL_ACCOUNTS_SUCCEEDED,
  FETCHING_TRIAL_ACCOUNTS_FAILED,
  FETCHING_SUSPENDED_ACCOUNTS,
  FETCHING_SUSPENDED_ACCOUNTS_SUCCEEDED,
  FETCHING_SUSPENDED_ACCOUNTS_FAILED,
  FETCHING_TERMINATED_ACCOUNTS,
  FETCHING_TERMINATED_ACCOUNTS_SUCCEEDED,
  FETCHING_TERMINATED_ACCOUNTS_FAILED,
  FETCHING_TOTAL_USERS,
  FETCHING_TOTAL_USERS_SUCCEEDED,
  FETCHING_TOTAL_USERS_FAILED,
  FETCHING_TOTAL_ASSETS,
  FETCHING_TOTAL_ASSETS_SUCCEEDED,
  FETCHING_TOTAL_ASSETS_FAILED,
  FETCHING_TOTAL_COLLECTIONS,
  FETCHING_TOTAL_COLLECTIONS_SUCCEEDED,
  FETCHING_TOTAL_COLLECTIONS_FAILED,
  FETCHING_TOTAL_STREAMS,
  FETCHING_TOTAL_STREAMS_SUCCEEDED,
  FETCHING_TOTAL_STREAMS_FAILED,
  FETCHING_WEEKLY_ACTIVE_USERS,
  FETCHING_WEEKLY_ACTIVE_USERS_SUCCEEDED,
  FETCHING_WEEKLY_ACTIVE_USERS_FAILED,
  FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE,
  FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_SUCCEEDED,
  FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_FAILED,
  FETCHING_MONTHLY_ACTIVE_USERS,
  FETCHING_MONTHLY_ACTIVE_USERS_SUCCEEDED,
  FETCHING_MONTHLY_ACTIVE_USERS_FAILED,
  FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE,
  FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_SUCCEEDED,
  FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_FAILED,
  FETCHING_STREAM_CREATION,
  FETCHING_STREAM_CREATION_SUCCEEDED,
  FETCHING_STREAM_CREATION_FAILED,
  FETCHING_ASSET_CREATION,
  FETCHING_ASSET_CREATION_SUCCEEDED,
  FETCHING_ASSET_CREATION_FAILED,
  FETCHING_COLLECTION_CREATION,
  FETCHING_COLLECTION_CREATION_SUCCEEDED,
  FETCHING_COLLECTION_CREATION_FAILED,
  FETCHING_ASSET_VIEWING,
  FETCHING_ASSET_VIEWING_SUCCEEDED,
  FETCHING_ASSET_VIEWING_FAILED,
  FETCHING_ASSET_SHARING,
  FETCHING_ASSET_SHARING_SUCCEEDED,
  FETCHING_ASSET_SHARING_FAILED,
  FETCHING_INTEGRATIONS,
  FETCHING_INTEGRATIONS_SUCCEEDED,
  FETCHING_INTEGRATIONS_FAILED,
  FETCHING_ADOPTION_ACCOUNTS,
  FETCHING_ADOPTION_ACCOUNTS_SUCCEEDED,
  FETCHING_ADOPTION_ACCOUNTS_FAILED,
  FETCHING_DAILY_ACTIVE_USERS,
  FETCHING_DAILY_ACTIVE_USERS_SUCCEEDED,
  FETCHING_DAILY_ACTIVE_USERS_FAILED,
  FETCHING_DAILY_ACTIVE_USERS_TIMELINE,
  FETCHING_DAILY_ACTIVE_USERS_TIMELINE_SUCCEEDED,
  FETCHING_DAILY_ACTIVE_USERS_TIMELINE_FAILED,
  FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_REQUEST,
  FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_SUCCEEDED,
  FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_FAILED,
  FETCHING_FLITEVIEW_LINK_OPEN_RATE_REQUEST,
  FETCHING_FLITEVIEW_LINK_OPEN_RATE_SUCCEEDED,
  FETCHING_FLITEVIEW_LINK_OPEN_RATE_FAILED,
  FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_REQUEST,
  FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_SUCCEEDED,
  FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_FAILED,
  FETCHING_FLITEVIEW_PERSONALISED_LINKS_REQUEST,
  FETCHING_FLITEVIEW_PERSONALISED_LINKS_SUCCEEDED,
  FETCHING_FLITEVIEW_PERSONALISED_LINKS_FAILED,
  FETCHING_FLITEVIEW_ANONYMOUS_LINKS_REQUEST,
  FETCHING_FLITEVIEW_ANONYMOUS_LINKS_SUCCEEDED,
  FETCHING_FLITEVIEW_ANONYMOUS_LINKS_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_COMPLETION_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_COMPLETION_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_COMPLETION_FAILED,
  FETCHING_TOTAL_LEADS_REQUEST,
  FETCHING_TOTAL_LEADS_SUCCEEDED,
  FETCHING_TOTAL_LEADS_FAILED,
  FETCHING_WEEKLY_ADOPTION_MATRIX_REQUEST,
  FETCHING_WEEKLY_ADOPTION_MATRIX_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_MATRIX_FAILED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_REQUEST,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_FAILED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_REQUEST,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_FAILED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_REQUEST,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_FAILED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_REQUEST,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_FAILED,
  FETCHING_WEEKLY_ADOPTION_LIST_REQUEST,
  FETCHING_WEEKLY_ADOPTION_LIST_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_LIST_FAILED,
} from "../constants/actionTypes.jsx";

const initialState = {
  accounts: {
    items: [],
    loading: false,
    success: false,
    error: null,
  },
  totalAccounts: {
    count: 0,
    data: [],
    loading: false,
    success: false,
    error: null,
  },
  newAccounts: {
    items: [],
    loading: false,
    success: false,
    error: null,
  },
  churnedAccounts: {
    items: [],
    loading: false,
    success: false,
    error: null,
  },
  trialAccounts: {
    items: [],
    loading: false,
    success: false,
    error: null,
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 20,
      totalRecordsCount: 0,
    },
  },
  suspendedAccounts: {
    items: [],
    loading: false,
    success: false,
    error: null,
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 20,
      totalRecordsCount: 0,
    },
  },
  terminatedAccounts: {
    items: [],
    loading: false,
    success: false,
    error: null,
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 20,
      totalRecordsCount: 0,
    },
  },
  acountMetrics: {
    users: 0,
    assets: 0,
    collections: 0,
    streams: 0,
    leads: 0,
  },
  userMetrics: {
    daily: {
      count: 0,
      data: [],
      loading: false,
    },
    weekly: {
      count: 0,
      data: [],
      loading: false,
    },
    monthly: {
      count: 0,
      data: [],
      loading: false,
    },
  },

  streamCreation: {
    items: [],
    loading: false,
    success: false,
    error: null,
  },
  assetCreation: {
    items: [],
    loading: false,
    success: false,
    error: null,
  },
  collectionCreation: {
    items: [],
    loading: false,
    success: false,
    error: null,
  },
  integrations: {
    items: [],
    loading: false,
    error: null,
  },
  fliteviewMetrics: {
    emailOpenRate: {
      count: 0,
    },
    linkOpenRate: {
      count: 0,
    },
    averageTimeSpent: {
      count: 0,
    },
    personalisedLinks: {
      count: 0,
    },
    anonymousLinks: {
      count: 0,
    },
    sessions: {
      count: 0,
    },
    personalisedSessions: {
      count: 0,
    },
    anonymousSessions: {
      count: 0,
    },
    completionSessions: {
      count: 0,
    },
    uniqueVisitors: {
      count: 0,
    },
  },
  weeklyAdoption: {
    matrix: {
      loading: false,
      items: [],
      success: false,
      errors: null,
    },
    timelineC1: {
      loading: false,
      items: [],
      success: false,
      errors: null,
    },
    timelineC2: {
      loading: false,
      items: [],
      success: false,
      errors: null,
    },
    timelineC3: {
      loading: false,
      items: [],
      success: false,
      errors: null,
    },
    timelineC4: {
      loading: false,
      items: [],
      success: false,
      errors: null,
    },
    list: {
      loading: false,
      items: [],
      pagination: {
        currentPage: -1,
        totalPages: 1,
        recordsPerPage: 20,
        totalRecordsCount: 0,
      },
    },
  },
};

function adoptionMetricsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_ADOPTION_ACCOUNTS:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          items: [],
          loading: true,
        },
      };

    case FETCHING_ADOPTION_ACCOUNTS_SUCCEEDED:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          loading: false,
          items: action.payload,
        },
      };

    case FETCHING_ADOPTION_ACCOUNTS_FAILED:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          loading: false,
          error: action.payload,
          items: []
        },
      };

    case FETCHING_TOTAL_NUMBER_OF_ACCOUNTS:
      return {
        ...state,
        totalAccounts: {
          ...state.totalAccounts,
          loading: true
        },
      };

    case FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_SUCCEEDED:
      return {
        ...state,
        totalAccounts: {
          ...state.totalAccounts,
          count: action.payload,
          loading: false,
        },
      };

    case FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_FAILED:
      return {
        ...state,
        totalAccounts: {
          ...state.totalAccounts,
          loading: false,
          error: action.payload,
          count: 0
        },
      };

    case FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE:
      return {
        ...state,
        totalAccounts: {
          ...state.totalAccounts,
          data: [],
          loading: true,
        },
      };

    case FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_SUCCEEDED:
      return {
        ...state,
        totalAccounts: {
          ...state.totalAccounts,
          data: action.payload,
          loading: false,
        },
      };

    case FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_FAILED:
      return {
        ...state,
        totalAccounts: {
          ...state.totalAccounts,
          loading: false,
          error: action.payload,
          data: []
        },
      };

    case FETCHING_NEW_ACCOUNTS:
      return {
        ...state,
        totalAccounts: {
          ...state.totalAccounts,
          items: [],
          loading: true,
        },
      };

    case FETCHING_NEW_ACCOUNTS_SUCCEEDED:
      return {
        ...state,
        newAccounts: {
          ...state.newAccounts,
          loading: false,
          items: action.payload,
        },
      };

    case FETCHING_NEW_ACCOUNTS_FAILED:
      return {
        ...state,
        newAccounts: {
          ...state.newAccounts,
          loading: false,
          error: action.payload,
          items: []
        },
      };

    case FETCHING_CHURNED_ACCOUNTS:
      return {
        ...state,
        churnedAccounts: {
          ...state.churnedAccounts,
          items: [],
          loading: true,
        },
      };

    case FETCHING_CHURNED_ACCOUNTS_SUCCEEDED:
      return {
        ...state,
        churnedAccounts: {
          ...state.churnedAccounts,
          items: action.payload,
          loading: false,
        },
      };

    case FETCHING_CHURNED_ACCOUNTS_FAILED:
      return {
        ...state,
        churnedAccounts: {
          ...state.churnedAccounts,
          loading: false,
          error: action.payload,
          items: []
        },
      };

    case FETCHING_TRIAL_ACCOUNTS:
      return {
        ...state,
        trialAccounts: {
          ...state.trialAccounts,
          loading: true,
          error: null,
        },
      };

    case FETCHING_TRIAL_ACCOUNTS_SUCCEEDED: {
      const {
        currentPage,
        recordsPerPage,
        totalPages,
        totalRecordsCount,
        records = [],
      } = action.payload;
      const items = currentPage === 0
        ? records
        : [...state.trialAccounts.items, ...records];

      return {
        ...state,
        trialAccounts: {
          ...state.trialAccounts,
          loading: false,
          items,
          pagination: {
            currentPage,
            totalPages,
            recordsPerPage,
            totalRecordsCount,
          },
        },
      };
    }

    case FETCHING_TRIAL_ACCOUNTS_FAILED:
      return {
        ...state,
        trialAccounts: {
          ...state.trialAccounts,
          loading: false,
          error: action.payload,
        },
      };
    case FETCHING_SUSPENDED_ACCOUNTS:
      return {
        ...state,
        suspendedAccounts: {
          ...state.suspendedAccounts,
          loading: true,
          error: null,
        },
      };

    case FETCHING_SUSPENDED_ACCOUNTS_SUCCEEDED: {
      const {
        currentPage,
        recordsPerPage,
        totalPages,
        totalRecordsCount,
        records = [],
      } = action.payload;
      const items = currentPage === 0
        ? records
        : [...state.suspendedAccounts.items, ...records];

      return {
        ...state,
        suspendedAccounts: {
          ...state.suspendedAccounts,
          loading: false,
          items,
          pagination: {
            currentPage,
            totalPages,
            recordsPerPage,
            totalRecordsCount,
          },
        },
      };
    }

    case FETCHING_SUSPENDED_ACCOUNTS_FAILED:
      return {
        ...state,
        suspendedAccounts: {
          ...state.suspendedAccounts,
          loading: false,
          error: action.payload,
        },
      };

    case FETCHING_TERMINATED_ACCOUNTS:
      return {
        ...state,
        terminatedAccounts: {
          ...state.terminatedAccounts,
          loading: true,
          error: null,
        },
      };

    case FETCHING_TERMINATED_ACCOUNTS_SUCCEEDED: {
      const {
        currentPage,
        recordsPerPage,
        totalPages,
        totalRecordsCount,
        records = [],
      } = action.payload;
      const items = currentPage === 0
        ? records
        : [...state.terminatedAccounts.items, ...records];

      return {
        ...state,
        terminatedAccounts: {
          ...state.terminatedAccounts,
          loading: false,
          items,
          pagination: {
            currentPage,
            totalPages,
            recordsPerPage,
            totalRecordsCount,
          },
        },
      };
    }

    case FETCHING_TERMINATED_ACCOUNTS_FAILED:
      return {
        ...state,
        terminatedAccounts: {
          ...state.terminatedAccounts,
          loading: false,
          error: action.payload,
        },
      };

    case FETCHING_TOTAL_USERS:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics
        },
      };

    case FETCHING_TOTAL_USERS_SUCCEEDED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          users: action.payload.value,
        },
      };

    case FETCHING_TOTAL_USERS_FAILED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          error: action.payload,
          users: 0
        },
      };

    case FETCHING_TOTAL_USERS:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
        }
      };

    case FETCHING_TOTAL_USERS_SUCCEEDED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          users: action.payload.value,
        },
      };

    case FETCHING_TOTAL_USERS_FAILED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          error: action.payload,
          users: 0
        },
      };

    case FETCHING_TOTAL_ASSETS:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
        }
      };

    case FETCHING_TOTAL_ASSETS_SUCCEEDED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          assets: action.payload.value,
        },
      };

    case FETCHING_TOTAL_ASSETS_FAILED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          error: action.payload,
          assets: 0
        },
      };

    case FETCHING_TOTAL_COLLECTIONS:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics
        },
      };

    case FETCHING_TOTAL_COLLECTIONS_SUCCEEDED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          collections: action.payload.value,
        },
      };

    case FETCHING_TOTAL_COLLECTIONS_FAILED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          error: action.payload,
          collections: 0
        },
      };

    case FETCHING_TOTAL_STREAMS:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
        }
      };

    case FETCHING_TOTAL_STREAMS_SUCCEEDED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          streams: action.payload.value,
        },
      };

    case FETCHING_TOTAL_STREAMS_FAILED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          error: action.payload,
          streams: 0
        },
      };
    case FETCHING_TOTAL_LEADS_REQUEST:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics
        },
      };

    case FETCHING_TOTAL_LEADS_SUCCEEDED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          leads: action.payload.value,
        },
      };

    case FETCHING_TOTAL_LEADS_FAILED:
      return {
        ...state,
        accountMetrics: {
          ...state.accountMetrics,
          leads: 0,
          error: action.payload
        },
      };

    case FETCHING_DAILY_ACTIVE_USERS:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          daily: {
            ...state.userMetrics.daily,
          }
        },
      };

    case FETCHING_DAILY_ACTIVE_USERS_SUCCEEDED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          daily: {
            ...state.userMetrics.daily,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_DAILY_ACTIVE_USERS_FAILED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          daily: {
            ...state.userMetrics.daily,
            count: 0
          },
          error: action.payload,
        },
      };

    case FETCHING_WEEKLY_ACTIVE_USERS:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          weekly: {
            ...state.userMetrics.weekly
          },
        },
      };

    case FETCHING_WEEKLY_ACTIVE_USERS_SUCCEEDED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          weekly: {
            ...state.userMetrics.weekly,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_WEEKLY_ACTIVE_USERS_FAILED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          weekly: {
            ...state.userMetrics.weekly,
            count: 0,
          },
          error: action.payload,
        },
      };

    case FETCHING_MONTHLY_ACTIVE_USERS:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          monthly: {
            ...state.userMetrics.monthly
          },
        },
      };

    case FETCHING_MONTHLY_ACTIVE_USERS_SUCCEEDED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          monthly: {
            ...state.userMetrics.monthly,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_MONTHLY_ACTIVE_USERS_FAILED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          monthly: {
            ...state.userMetrics.monthly,
            count: 0,
          },
          error: action.payload
        },
      };

    case FETCHING_DAILY_ACTIVE_USERS_TIMELINE:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          daily: {
            ...state.userMetrics.daily,
            data: [],
          },
        },
      };

    case FETCHING_DAILY_ACTIVE_USERS_TIMELINE_SUCCEEDED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          daily: {
            ...state.userMetrics.daily,
            data: action.payload,
          },
        },
      };

    case FETCHING_DAILY_ACTIVE_USERS_TIMELINE_FAILED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          daily: {
            ...state.userMetrics.daily,
            data: [],
          },
          error: action.payload,
        },
      };

    case FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          weekly: {
            ...state.userMetrics.weekly,
            data: [],
          },
        },
      };

    case FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_SUCCEEDED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          weekly: {
            ...state.userMetrics.weekly,
            data: action.payload,
          },
        },
      };

    case FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_FAILED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          weekly: {
            ...state.userMetrics.weekly,
            data: [],
          },
          error: action.payload,
        },
      };

    case FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          monthly: {
            ...state.userMetrics.monthly,
            data: [],
          },
        },
      };

    case FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_SUCCEEDED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          monthly: {
            ...state.userMetrics.monthly,
            data: action.payload,
          },
        },
      };

    case FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_FAILED:
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          monthly: {
            ...state.userMetrics.monthly,
            data: [],
          },
          error: action.payload,
        },
      };

    case FETCHING_ASSET_CREATION:
      return {
        ...state,
        assetCreation: {
          ...state.assetCreation,
          items: [],
          loading: true,
        },
      };

    case FETCHING_ASSET_CREATION_SUCCEEDED:
      return {
        ...state,
        assetCreation: {
          ...state.assetCreation,
          items: action.payload,
          loading: false,
        },
      };

    case FETCHING_ASSET_CREATION_FAILED:
      return {
        ...state,
        assetCreation: {
          ...state.assetCreation,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    case FETCHING_STREAM_CREATION:
      return {
        ...state,
        streamCreation: {
          ...state.streamCreation,
          items: [],
          loading: true,
        },
      };

    case FETCHING_STREAM_CREATION_SUCCEEDED:
      return {
        ...state,
        streamCreation: {
          ...state.streamreation,
          items: action.payload,
          loading: false,
        },
      };

    case FETCHING_STREAM_CREATION_FAILED:
      return {
        ...state,
        streamCreation: {
          ...state.streamCreation,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    case FETCHING_COLLECTION_CREATION:
      return {
        ...state,
        collectionCreation: {
          ...state.collectionCreation,
          items: [],
          loading: true,
        },
      };

    case FETCHING_COLLECTION_CREATION_SUCCEEDED:
      return {
        ...state,
        collectionCreation: {
          ...state.collectionCreation,
          items: action.payload,
          loading: false,
        },
      };

    case FETCHING_COLLECTION_CREATION_FAILED:
      return {
        ...state,
        collectionCreation: {
          ...state.collectionCreation,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    case FETCHING_ASSET_SHARING:
      return {
        ...state,
        assetSharing: {
          ...state.assetSharing,
          items: [],
          loading: true,
        },
      };

    case FETCHING_ASSET_SHARING_SUCCEEDED:
      return {
        ...state,
        assetSharing: {
          ...state.assetSharing,
          items: action.payload,
          loading: false,
        },
      };

    case FETCHING_ASSET_SHARING_FAILED:
      return {
        ...state,
        assetSharing: {
          ...state.assetSharing,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    case FETCHING_ASSET_VIEWING:
      return {
        ...state,
        assetViewing: {
          ...state.assetViewing,
          items: [],
          loading: true,
        },
      };

    case FETCHING_ASSET_VIEWING_SUCCEEDED:
      return {
        ...state,
        assetViewing: {
          ...state.assetViewing,
          items: action.payload,
          loading: false,
        },
      };

    case FETCHING_ASSET_VIEWING_FAILED:
      return {
        ...state,
        assetViewing: {
          ...state.assetViewing,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    case FETCHING_INTEGRATIONS:
      return {
        ...state,
        integrations: {
          ...state.integrations,
          items: [],
          loading: true,
        },
      };

    case FETCHING_INTEGRATIONS_SUCCEEDED:
      var items = [];
      var integrations = action.payload || [];
      integrations.forEach((item, index) => {
        items.push({ text: item.text, value: item.value });
      });
      return {
        ...state,
        integrations: {
          ...state.integrations,
          items: items,
          loading: false,
        },
      };

    case FETCHING_INTEGRATIONS_FAILED:
      return {
        ...state,
        integrations: {
          ...state.integrations,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    case FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          emailOpenRate: {
            ...state.fliteviewMetrics.emailOpenRate
          },
        },
      };

    case FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_SUCCEEDED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          emailOpenRate: {
            ...state.fliteviewMetrics.emailOpenRate,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_FAILED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          emailOpenRate: {
            ...state.fliteviewMetrics.emailOpenRate,
            count: 0
          },
        },
      };

    case FETCHING_FLITEVIEW_LINK_OPEN_RATE_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          linkOpenRate: {
            ...state.fliteviewMetrics.linkOpenRate
          },
        },
      };

    case FETCHING_FLITEVIEW_LINK_OPEN_RATE_SUCCEEDED:
      console.log("fliteview", action.payload);

      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          linkOpenRate: {
            ...state.fliteviewMetrics.linkOpenRate,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_LINK_OPEN_RATE_FAILED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          linkOpenRate: {
            ...state.fliteviewMetrics.linkOpenRate,
            count: 0
          },
        },
      };

    case FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          averageTimeSpent: {
            ...state.fliteviewMetrics.averageTimeSpent
          },
        },
      };

    case FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_SUCCEEDED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          averageTimeSpent: {
            ...state.fliteviewMetrics.averageTimeSpent,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_FAILED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          averageTimeSpent: {
            ...state.fliteviewMetrics.averageTimeSpent,
            count: 0
          },
        },
      };

    case FETCHING_FLITEVIEW_PERSONALISED_LINKS_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          personalisedLinks: {
            ...state.fliteviewMetrics.personalisedLinks
          },
        },
      };

    case FETCHING_FLITEVIEW_PERSONALISED_LINKS_SUCCEEDED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          personalisedLinks: {
            ...state.fliteviewMetrics.personalisedLinks,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_PERSONALISED_LINKS_FAILED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          personalisedLinks: {
            ...state.fliteviewMetrics.personalisedLinks,
            count: 0
          },
        },
      };

    case FETCHING_FLITEVIEW_ANONYMOUS_LINKS_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          anonymousLinks: {
            ...state.fliteviewMetrics.anonymousLinks
          },
        },
      };

    case FETCHING_FLITEVIEW_ANONYMOUS_LINKS_SUCCEEDED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          anonymousLinks: {
            ...state.fliteviewMetrics.anonymousLinks,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_ANONYMOUS_LINKS_FAILED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          anonymousLinks: {
            ...state.fliteviewMetrics.anonymousLinks,
            count: 0
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          sessions: {
            ...state.fliteviewMetrics.sessions
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_SUCCEEDED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          sessions: {
            ...state.fliteviewMetrics.sessions,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_FAILED:
      return {
        ...state,
        sessions: {
          ...state.fliteviewMetrics,
          sessions: {
            ...state.fliteviewMetrics.sessions,
            count: 0
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          personalisedSessions: {
            ...state.fliteviewMetrics.personalisedSessions
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_SUCCEEDED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          personalisedSessions: {
            ...state.fliteviewMetrics.personalisedSessions,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_FAILED:
      return {
        ...state,
        personalisedSessions: {
          ...state.fliteviewMetrics,
          personalisedSessions: {
            ...state.fliteviewMetrics.personalisedSessions,
            count: 0
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          anonymousSessions: {
            ...state.fliteviewMetrics.anonymousSessions
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_SUCCEEDED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          anonymousSessions: {
            ...state.fliteviewMetrics.anonymousSessions,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_FAILED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          anonymousSessions: {
            ...state.fliteviewMetrics.anonymousSessions,
            count: 0
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          uniqueVisitors: {
            ...state.fliteviewMetrics.uniqueVisitors
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_SUCCEEDED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          uniqueVisitors: {
            ...state.fliteviewMetrics.uniqueVisitors,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_FAILED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          uniqueVisitors: {
            ...state.fliteviewMetrics.uniqueVisitors,
            count: 0
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_COMPLETION_REQUEST:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          completionSessions: {
            ...state.fliteviewMetrics.completionSessions
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_COMPLETION_SUCCEEDED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          completionSessions: {
            ...state.fliteviewMetrics.completionSessions,
            count: action.payload.value,
          },
        },
      };

    case FETCHING_FLITEVIEW_SESSIONS_COMPLETION_FAILED:
      return {
        ...state,
        fliteviewMetrics: {
          ...state.fliteviewMetrics,
          completionSessions: {
            ...state.fliteviewMetrics.completionSessions,
            count: 0
          },
        },
      };
    case FETCHING_WEEKLY_ADOPTION_MATRIX_REQUEST:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          matrix: {
            loading: true,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_MATRIX_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          matrix: {
            loading: false,
            success: true,
            items: action.payload,
            errors: [],
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_MATRIX_FAILED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          matrix: {
            loading: false,
            success: false,
            items: [],
            errors: action.payload,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_REQUEST:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC1: {
            loading: true,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC1: {
            loading: false,
            success: true,
            items: action.payload,
            errors: [],
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_FAILED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC1: {
            loading: false,
            success: false,
            items: [],
            errors: action.payload,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_REQUEST:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC2: {
            loading: true,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC2: {
            loading: false,
            success: true,
            items: action.payload,
            errors: [],
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_FAILED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC2: {
            loading: false,
            success: false,
            items: [],
            errors: action.payload,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_REQUEST:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC3: {
            loading: true,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC3: {
            loading: false,
            success: true,
            items: action.payload,
            errors: [],
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_FAILED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC3: {
            loading: false,
            success: false,
            items: [],
            errors: action.payload,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_REQUEST:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC4: {
            loading: true,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC4: {
            loading: false,
            success: true,
            items: action.payload,
            errors: [],
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_FAILED:
      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          timelineC4: {
            loading: false,
            success: false,
            items: [],
            errors: action.payload,
          },
        },
      });
    case FETCHING_WEEKLY_ADOPTION_LIST_REQUEST: {
      const { page } = action.payload;

      if (page !== 0) {
        return Object.assign({}, state, {
          ...state,
          weeklyAdoption: {
            ...state.weeklyAdoption,
            list: {
              ...state.weeklyAdoption.list,
              loading: true,
            },
          },
        });
      }

      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: { ...state.weeklyAdoption, list: { loading: true } },
      });
    }
    case FETCHING_WEEKLY_ADOPTION_LIST_SUCCEEDED: {

      var items = state.weeklyAdoption.list.items;
      var {
        currentPage,
        totalPages,
        recordsPerPage,
        totalRecordsCount,
        records = [],
      } = action.payload;

      if (currentPage !== 0) {
        items = [...state.weeklyAdoption.list.items, ...records];
      } else {
        items = records;
      }

      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          list: {
            loading: false,
            items: items,
            pagination: {
              ...state.pagination,
              currentPage,
              totalPages,
              recordsPerPage,
              totalRecordsCount,
            },
          },
        },
      });
    }
    case FETCHING_WEEKLY_ADOPTION_LIST_FAILED: {

      return Object.assign({}, state, {
        ...state,
        weeklyAdoption: {
          ...state.weeklyAdoption,
          list: {
            loading: false,
            items: [],
            pagination: {
              currentPage: -1,
              totalPages: 1,
              recordsPerPage: 20,
              totalRecordsCount: 0,
            },
          },
        },
      });
    }

    default:
      return state;
  }
}

export { adoptionMetricsReducer };
